<template>
    <div v-if="!recoverEmailSent">
        <div>
            <h5 class="title">
                {{ $t('shared.loginModule.forgotPassword.title') }}
            </h5>
            <p>
                {{ $t('shared.loginModule.forgotPassword.description') }}
            </p>
        </div>
        <form @submit.prevent="resetPassword">
            <TextField
                ref="emailField"
                :placeholder="$t('general.email')"
                type="email"
                v-model="email"
                padding
                margin
            />
            <BaseButton class="w-100 pa-2" variant="primary">
                {{ $t('shared.loginModule.forgotPassword.resetPassword') }}
            </BaseButton>
        </form>
    </div>
    <div v-else class="d-flex flex-column align-items-center">
        <h4 class="text-center primary-color">
            {{ $t('shared.loginModule.forgotPassword.emailSentTitle') }}
        </h4>
        <BaseIcon class="primary-color mt-2 mb-3" name="envelope" size="3x" />
        <p
            class="subtitle text-center mb-0"
            v-html="
                $t('shared.loginModule.forgotPassword.emailHasBeenSent', {
                    email: email,
                })
            "
        />
        <div class="mt-5">
            <p class="text-center mb-0 caption">
                {{ $t('shared.loginModule.forgotPassword.noEmail') }}
            </p>
            <BaseButton class="primary-color" @click="resetPassword">
                {{
                    $t('shared.loginModule.forgotPassword.sendEmailOneMoreTime')
                }}
            </BaseButton>
        </div>
    </div>
</template>

<script>
import states from '../states';
import { recoverPasswordURL } from '~/utils/urlUtils';

export default {
    props: {
        value: Boolean, // Is loading
        state: String,
    },
    data: () => ({
        email: '',
        recoverEmailSent: false,
    }),
    methods: {
        setLoading(value) {
            this.$emit('input', value);
        },
        resetPassword() {
            this.setLoading(true);
            this.sendRecoverPasswordEmail()
                .then(data => {
                    this.recoverEmailSent = true;
                })
                .catch(error => {
                    this.$interfaces.messageModule.addNewMessage({
                        state: 'ERROR',
                        title: this.$t(
                            'shared.loginModule.forgotPassword.resendErrorTitle'
                        ),
                        message: this.$t(
                            'shared.loginModule.forgotPassword.resendErrorMessage'
                        ),
                    });
                    this.recoverEmailSent = false;
                })
                .finally(() => this.setLoading(false));
        },
        goToLogIn() {
            this.$emit('stateChange', states.LOGIN);
        },
        sendRecoverPasswordEmail() {
            return this.$interfaces.user['forgot-password'].post({
                body: { email: this.email, returnUrl: recoverPasswordURL() },
            });
        },
        focusOnEmail() {
            this.$nextTick(() => {
                this.$refs.emailField.focus();
            });
        },
    },
    watch: {
        // If ForgotPassword state was initialized, reset this view
        state(newState) {
            if (newState === states.FORGOT_PASSWORD) {
                this.recoverEmailSent = false;
                this.email = '';
            }
        },
    },
};
</script>

<style scoped>
.action-section {
    margin-top: 140px;
}
</style>
